// Cómo se le muestra al vendedor un bono de promoción, sea de la promo de crédito o de la de venta.
import { formatMXN } from '@/shared/lib/format/money';
import type { components } from '@/api/services/retail-promotions/retail-promotions.gen';
import type { CreditPromotionBonusStatus } from './types';

export type PromotionBonusDisplayStatus = 'PAID' | 'IN_PROCESS' | 'IN_REVIEW';

/** Estado de la entrega de la promo de venta (Wallet) que manda Promociones. */
export type SaleBonusState = components['schemas']['EntitlementStateEnum'];

export type PromotionBonusSource =
    | { kind: 'CREDIT'; status: CreditPromotionBonusStatus }
    | { kind: 'SALE'; state: SaleBonusState };

const CREDIT_DISPLAY: Record<CreditPromotionBonusStatus, PromotionBonusDisplayStatus | null> = {
    SETTLED: 'PAID',
    RESERVED: 'IN_PROCESS',
    UNVERIFIED: 'IN_REVIEW',
    FAILED: null,
};

const SALE_DISPLAY: Record<SaleBonusState, PromotionBonusDisplayStatus | null> = {
    SETTLED: 'PAID',
    PENDING: 'IN_PROCESS',
    IN_FLIGHT: 'IN_PROCESS',
    UNVERIFIED: 'IN_REVIEW',
    VOID: null,
};

/** Lo que ve el vendedor; `null` = no se muestra (falló o se anuló, queda en el libro). */
export function promotionBonusDisplayStatus(
    source: PromotionBonusSource,
): PromotionBonusDisplayStatus | null {
    return source.kind === 'CREDIT' ? CREDIT_DISPLAY[source.status] : SALE_DISPLAY[source.state];
}

/** Texto de la línea del bono; «en revisión» nunca dice «falló»: pudo moverse dinero. */
export function promotionBonusText(
    display: PromotionBonusDisplayStatus,
    amountCents: number,
): string {
    const amount = formatMXN(amountCents / 100);
    if (display === 'PAID') return `Bono de ${amount} depositado en tu cuenta`;
    if (display === 'IN_PROCESS') return `Bono de ${amount} en proceso`;
    return `Bono de ${amount} en revisión, te avisamos`;
}
